<ion-button *ngIf="!cardToolsProvider.isEmpty" expand="block" (click)="onCardToolsClicked()">
  <ion-icon slot="start" name="add-circle-outline"></ion-icon>
  {{ 'Mobile.Add' | translate }}
</ion-button>
